import { render, staticRenderFns } from "./IframeDialog.vue?vue&type=template&id=3ea5a2e6&scoped=true&"
import script from "./IframeDialog.vue?vue&type=script&lang=ts&"
export * from "./IframeDialog.vue?vue&type=script&lang=ts&"
import style0 from "./IframeDialog.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./IframeDialog.vue?vue&type=style&index=1&id=3ea5a2e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea5a2e6",
  null
  
)

export default component.exports